﻿import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../../resources/ResourcesStore";
import { injectFromApp } from "../../inject";
import type { IAboutUsDialogStore } from "./about-us/AboutUsDialogStore";
import { AboutUsDialogComponent } from "./about-us/AboutUsDialogComponent";
import { IProductInfoStore } from "../../product-info/ProductInfoStore";

interface IHelpMenuComponentProps {
    resourcesStore?: IResourcesStore;
    aboutUsDialogStore?: IAboutUsDialogStore;
    productInfoStore?: IProductInfoStore;
}

@injectFromApp<IHelpMenuComponentProps>((stores) => ({
    resourcesStore: stores.resourcesStore,
    aboutUsDialogStore: stores.aboutUsDialogStore,
    productInfoStore: stores.productInfoStore
}))

@observer
export class HelpMenuComponent extends React.Component<IHelpMenuComponentProps> {
    private readonly openAboutBox = () => {
        const { aboutUsDialogStore } = this.props;
        aboutUsDialogStore!.setOpen(true);
    };

    render() {
        const { resourcesStore, productInfoStore } = this.props;
        const { resources } = resourcesStore!;
        const { isMedicalDevice } = productInfoStore!;

        return (
            <>
                <div id="help-menu">
                    <ul>
                        <li>
                            <a className="link-to-about-box" onClick={ this.openAboutBox }>
                                { resources.About } DeepUnity PACSonWEB { !isMedicalDevice && "Core" }
                            </a>
                        </li>
                        <li>
                            <a className="link-to-user-manual" href={ "/POW3/Resource/LocalHelpFile" } target={ "_blank" } rel="noreferrer">
                                { " " }
                                {/* Move link to POW4 */ }
                                { resources.UserManual } ({ resources.Online })
                            </a>
                        </li>
                        <li>
                            <a className="link-to-user-manual" href="/POW3/Resource/GetManualPDF" target="_blank" rel="noreferrer">
                                { " " }
                                {/* Move link to POW4 */ }
                                { resources.UserManual } ({ resources.PDF })
                            </a>
                        </li>
                        <li>
                            <a className="link-to-support" href={ "/POW3/Support" }>
                                { " " }
                                {/* Move link to POW4 and use current source for source specific support page */ }
                                { resources.Support }
                            </a>
                        </li>
                        <li>
                            <a className="link-to-download-app" href="/POW3/Resource/GetPacsonwebApplicationInstaller" target="_blank" rel="noreferrer">
                                { resources.DownloadPACSonWEBApplication }
                            </a>
                        </li>
                    </ul>
                </div>
                <AboutUsDialogComponent/>
            </>
        );
    }
}
